export default __webpack_public_path__ + "static/media/instruc_2.c5bd52ec.png";